import Box from '@mui/material/Box'
import { pageVars } from '../../../../../pages/const/pageVars'

const SecondModalMessage = ({ type, pageCodeText }) => {
  return (
    <Box
      component='span'
      sx={(theme) => ({
        ...theme.typography.p,
        alignItems: 'center',
        color: theme.palette.tertiary.main,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
      })}
    >
      <span>
        Are you sure you want to{' '}
        {(type === 'suspension' && 'suspend') ||
          (type === 'activation' && 'flag for activation') ||
          (type === 'deletion' && 'permanently delete')}{' '}
        selected
      </span>
      <span>
        {pageVars[pageCodeText].singular}(s) and its data connections?
      </span>
    </Box>
  )
}

export default SecondModalMessage
